import type { DiscountType } from '../types/offerListType';

/** Format validity period as "DD/MM/YYYY - DD/MM/YYYY" (per design) */
export function formatValidityPeriod(
  startDate: string | null | undefined,
  endDate: string | null | undefined
): string {
  if (!startDate || !endDate) {
    return '—';
  }
  try {
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return '—';
    }
    const day = (d: Date) => String(d.getDate()).padStart(2, '0');
    const month = (d: Date) => String(d.getMonth() + 1).padStart(2, '0');
    const y = (d: Date) => d.getFullYear();
    return `${day(start)}/${month(start)}/${y(start)} - ${day(end)}/${month(end)}/${y(end)}`;
  } catch {
    return '—';
  }
}

/** Polish label for discount type */
export function getDiscountTypeLabel(type: DiscountType): string {
  return type === 'PERCENTAGE' ? 'Procentowy' : 'Kwotowy';
}

/** Format discount value: "10%" or "20 zł". Never displays raw API strings. */
export function formatDiscountValue(type: DiscountType, value: number): string {
  const num = typeof value === 'number' && Number.isFinite(value) ? value : 0;
  if (type === 'PERCENTAGE') {
    return `${num}%`;
  }
  return `${num} zł`;
}
